import { ParkingArea } from '../../types/parking';
import { BuildingStructure } from '../../types/protocols';
import { LevelImpl, RoomImpl } from '../../types/implementations';
import { AREA_BLUEPRINT_STATUS_TEXT } from '../../Helpers/parkingUtils';

/**
 * "Rum 12 - Garage, Plan -1" for an area's linked room and its level, the
 * missing-reference copy when the room or level is gone, or undefined when the area has no room.
 */
export const parkingAreaRoomLabel = (
    area: Pick<ParkingArea, 'roomKey'>,
    structure: BuildingStructure | undefined
): string | undefined => {
    if (!area.roomKey) return undefined;
    const room = structure?.rooms?.[area.roomKey];
    if (!room) return AREA_BLUEPRINT_STATUS_TEXT.roomMissing;
    const roomName = new RoomImpl(room).displayName();
    if (!room.levelKey) return `${roomName} (${AREA_BLUEPRINT_STATUS_TEXT.roomHasNoLevel.toLowerCase()})`;
    const level = structure?.levels?.[room.levelKey];
    if (!level) return `${roomName} (${AREA_BLUEPRINT_STATUS_TEXT.levelMissing.toLowerCase()})`;
    return `${roomName}, ${new LevelImpl(level).displayName()}`;
};
